import { type Theme } from '../../../theme';
import { type ButtonStyles } from '../button.types';

export const getOutlineDestructiveButton = (theme: Theme): ButtonStyles => ({
  base: {
    background: 'transparent',
    color: theme.button.outlineDestructive.label,
    border: `1px solid ${theme.button.outlineDestructive.default}`,
    '&:hover': {
      borderColor: theme.button.outlineDestructive.hover,
      background: 'transparent',
    },
    '&:active, &:focus:not(:focus-visible)': {
      borderColor: theme.button.outlineDestructive.pressed,
      outline: 'none',
    },
    '&:focus': {
      outline: `2.5px solid ${theme.button.focused.desctructive}`,
      outlineOffset: 4,
      borderColor: theme.button.outlineDestructive.default,
      backgroundColor: 'transparent',
    },
  },
  active: {},
  isLoading: {},
  disabled: {
    border: `1px solid ${theme.border.interactive.disabled}`,
    color: theme.button.disabled.label,
    cursor: 'not-allowed',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active, &:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none',
    },
    svg: {
      color: theme.text.interactive.disabled,
    },
  },
});
